// extracted by mini-css-extract-plugin
export default {"container":"SubTitle_container__AyoqY","activityText":"SubTitle_activityText__Y2FST","avatar":"SubTitle_avatar__PQeQP"};